import { render } from "./BrNavigation.vue?vue&type=template&id=6ed1eb00&scoped=true"
import script from "./BrNavigation.vue?vue&type=script&lang=js"
export * from "./BrNavigation.vue?vue&type=script&lang=js"

import "./BrNavigation.vue?vue&type=style&index=0&id=6ed1eb00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed1eb00"]])

export default __exports__